<template>
    <div id="view-employee">
<h3>Medewerker</h3>

<p>naam: {{firstname}} {{lastname}}</p>

<button class="btn btn-warning" @click="deleteUser">verwijderen</button>
    </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
    name: "view-employee",
    data () {
        return {
            employee_id: null,
            firstname: null,
            lastname: null,
            roles: [],

        }
    },
    beforeRouteEnter (to, from, next) {
        fb.usersCollection.doc(to.params.employee_id).get().then(doc => {
                    console.log(doc.data())
                next(vm => {
                    vm.employee_id = doc.id
                    vm.firstname = doc.data().firstname
                    vm.lastname = doc.data().lastname
                    vm.roles = doc.data().roles
                })
        })
    },
    // watch: {
    //     '$route': 'fetchData'
    // },
    methods: {
        // fetchData () {
        //     fb.usersCollection.doc(this.$route.params.employee_id).get().then(doc => {
        //             this.employee_id = doc.id
        //             this.firstname = doc.data().firstname
        //             this.lastname = doc.data().lastname
        //             this.roles = doc.data().roles
              
        // })
        // }
        deleteUser () {
            if (confirm('Medewerker verwijderen?')) {
                var th = this;
                fb.usersCollection.doc(this.employee_id).delete().then(function() {
                    console.log("medewerker verwijderd")
                    th.$router.push('/employees')
                }).catch(function(error){
                    console.log("Error deleting: ", error)
                })
            }
        }
    }
}
</script>